/**
 * ProtectedRoute — auth gate for the admin workspace.
 *
 * Fails closed: a session is only admitted with a current server staff role.
 * A missing or unknown role, or the customer `viewer`
 * role all land on /unauthorized.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isStaffRole } from '@pazportal/types';
import { useAuth } from '../contexts/AuthContext';
import { adminLoginPath } from '../lib/mcpLoginContinuation';

export function ProtectedRoute() {
  const { session, loading, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface" role="status" aria-live="polite">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-3 border-primary border-t-transparent rounded-full animate-spin" aria-hidden="true" />
          <span className="text-sm font-semibold text-primary">PazNetworks, Inc.</span>
          <span className="sr-only">Checking your session</span>
        </div>
      </div>
    );
  }

  if (!session) return <Navigate to={adminLoginPath(location.pathname, location.search)} replace />;
  if (!isStaffRole(role)) return <Navigate to="/unauthorized" replace />;

  return <Outlet />;
}
